<template>
  <Button
    :to="to"
    :href="href"
    class="flex items-center justify-center rounded font-bold"
    :class="{
      'border-2 border-gray-500 text-gray-500 hover:border-gray-600 hover:bg-gray-300 hover:text-gray-600':
        variant === 'outlined',
      'cursor-not-allowed': disabled,
      'text-white': variant === 'primary',
      'bg-gray-500 hover:bg-gray-600': variant === 'primary' && !disabled,
      'bg-gray-200': variant === 'primary' && disabled,
      'bg-gray-300 text-gray-800': variant === 'secondary',
      'bg-red-500 px-4 py-2 text-white hover:bg-red-700': variant === 'danger',
    }"
    :label="label"
    :style="{
      padding: rescaleUnit * 0.5 + 'rem',
      fontSize: rescaleUnit * 1.25 + 'rem',
      lineHeight: rescaleUnit * 1.75 + 'rem',
      gap: rescaleUnit * 0.5 + 'rem',
    }"
    :disabled="disabled || loading"
  >
    <i-mdi:loading v-if="loading" class="h-7 animate-spin" />
    <template v-else>
      <slot />
      <template v-if="!hideLabel">
        {{ label }}
      </template>
    </template>
  </Button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: 'primary' | 'secondary' | 'danger' | 'outlined';
    disabled?: boolean;
    label: string;
    to?: string;
    href?: string;
    rescaleUnit?: number;
    hideLabel?: boolean;
    loading?: boolean;
  }>(),
  {
    variant: 'primary',
    to: '',
    href: undefined,
    rescaleUnit: 1,
  },
);
</script>
